<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title"> </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-toggle="dropdown" title="Công cụ">
                        <i class="fas fa-cogs"></i>
                        <div class="input-group-prepend">
                            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                <export-excel class="dropdown-item text-green" :data="exportDatas" worksheet="report" type="xls" name="report.xls">
                                    <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Xuất file Excel
                                </export-excel>
                                <div class="dropdown-divider"></div>
                            </div>
                        </div>
                    </button>
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button> -->
                    <!-- <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button> -->

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="row mb-2">
                    <!-- <div class="col-md-3 mb-3">
                        <TheSelect id="" title="" :options="pageOptions" :initialValue="perPage.toString()" @onChange="(v) => onChangePageOptions(v)" />
                    </div> -->
                    <div class="col-md-3">
                        <select id="workspaceOptions" class="form-control select2bs4" style="width: 100%" v-model="selectedWorkspace">
                            <option v-for="item in workspaceOptions" :value="item.id" :key="item.id">{{ item.operatingCenterName }}</option>
                        </select>
                    </div>
                    <!-- <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </div> -->
                </div>
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">#</th>
                                <th class="col80">Tên dataset</th>
                                <th class="col200"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="item.id">
                                <td @click="selectRow(item.id)" style="vertical-align: middle !important;">{{ index + 1 }}</td>
                                <td @click="selectRow(item.id)" style="vertical-align: middle;">{{ item.name }}</td>
                                <td style="vertical-align: middle;">
                                    <button type="button" size="lg" class="btn btn-outline-success btn-sm" :disabled="isLoading" v-on:click="onClickRefreshDataset(item)" title="Làm mới dữ liệu">
                                        <i class="fa-solid fa-rotate-right"></i>
                                    </button>&nbsp;
                                    <!-- <button type="button" size="lg" class="btn btn-outline-danger btn-sm" :disabled="isLoading" v-on:click="onClickSchedule(item)" title="Lập lịch">
                                        <i class="fa-solid fa-calendar-days"></i>
                                    </button>&nbsp; -->
                                    <button type="button" size="lg" class="btn btn-outline-primary btn-sm" :disabled="isLoading" v-on:click="onClickHistoryRefresh(item)" title="Lịch sử">
                                        <i class="fa-solid fa-clock-rotate-left"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <p> Selected Rows:<br>{{ selected }} </p> -->
                <!-- row info and paging -->
                <!-- <div class="row">
                    <div class="col-md-6">
                        <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng</div>
                        <div v-else>Không có dữ liệu</div>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right">
                            <ul class="pagination pagination-rounded">
                                <paginate :page-count="pageCount" :page-range="3" :margin-pages="2"
                                    :click-handler="handlePageChange" :prev-text="'Trở lại'" :next-text="'Kế đến'"
                                    :container-class="'pagination'" :page-class="'page-item'">
                                </paginate>
                            </ul>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>

        <!-- POP UP SCHEDULE -->
        <div class="modal fade" id="scheduleModal" data-keyboard="false" data-backdrop="dynamic"> <!-- data-backdrop="static" -->
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Lập lịch</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideScheduleModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div v-if="!isLoading" class="form-group">
                            <div class="custom-control custom-checkbox mr-sm-2">
                                <input type="checkbox" class="custom-control-input" id="enableSchedule" v-model="refreshScheduleEnabled">
                                <label class="custom-control-label" for="enableSchedule">Cho phép lập lịch</label>
                            </div>
                        </div>
                        <div v-if="!isLoading" class="form-group">
                            <label for="">Thời gian lập lịch</label>
                            <div id="selectSheduleTimes">
                                <!-- <div class="row mb-1">
                                    <div class="col-4">
                                        <div class="d-flex">
                                            <select class="form-control" name="scheduleHours" id="">
                                                <option value="01">01</option>
                                                <option value="02">02</option>
                                            </select>
                                            <select class="form-control ml-1" name="scheduleMinutes" id="">
                                                <option value="00">00</option>
                                                <option value="30">30</option>
                                            </select>
                                            <button class="btn btn-sm btn-outline-danger ml-1">
                                                <i class="fa-solid fa-trash-can"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div> -->
                            </div>
                            <div v-if="numberOfScheduleStep < 8">
                                <button class="btn btn-sm btn-outline-primary" @click="onAddScheduleStep(this)">
                                    <i class="fa-solid fa-plus"></i>
                                    Thêm bước
                                </button>
                            </div>
                        </div>
                        <div v-if="isLoading" class="text-center">
                            <div class="spinner-border" role="status">
                                <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideScheduleModal()">&nbsp;Đóng</button>
                        <button v-if="!isLoading" type="button" class="btn btn-outline-success pull-right" :disabled="isLoading" :class="styleButton" @click="onSubmitSchedule();">
                            <span v-if="isLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            &nbsp;Cập nhật
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP REFRESH HISTORY  -->
        <div class="modal fade" id="refreshHistoryModal" data-keyboard="false" data-backdrop="dynamic"> <!-- data-backdrop="static" -->
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Lịch sử</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideRefreshHistoryModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <table class="table table-hover" id="refreshHistoryTable">
                            <thead>
                                <tr>
                                    <th class="col5">#</th>
                                    <!-- <th class="col80">Loại</th> -->
                                    <th class="col200">Bắt đầu</th>
                                    <th class="col200">Kết thúc</th>
                                    <th class="col200">Trạng thái</th>
                                </tr>
                            </thead>
                            <tbody>
                                
                            </tbody>
                        </table>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideRefreshHistoryModal()">&nbsp;Đóng</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import { mapActions } from 'vuex'
import config from '@/config/prod.env';
import common from '@/helper/common.js';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';

export default {
    components: {
        // paginate: Paginate,
        loading: Loading,
        //TheSelect
    },
    name: "TheDataset",
    data() {
        return {
            isBusy: false,
            streamFileUrl: `${process.env.VUE_APP_API_URL}/Common/StreamFile?url=`,
            // table
            filter: null,
            items: [],
            exportDatas: [],
            currentPage: config.CURRENT_PAGE,
            perPage: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: "createdDate",
            sortDesc: true,
            filterOn: [],
            numberOfShow: 0,

            selectedWorkspace: null,
            workspaceOptions: [],

            selectedDataset: null,
            reportOptions: [],

            numberOfScheduleStep: 0,

            

            hourOptions: ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23'],
            minuteOptions: ['00', '30'],
            refreshScheduleEnabled: false,

            selectedDatasetId: '',

            title: "",
            code: "",
            styleButton: "",
            // For mesage validate
            errors: {},
            isLoading: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('dataset', ['getPBIDatasets', 'refreshDataset', 'getRefreshSchedule', 'updateRefreshSchedule', 'getRefreshHistory']),
        ...mapActions('workspace', ['getAllWorkspace']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Quản lý dataset';
            this.setupHeader({ header });            
            
            // get workspaces
            let getWPResult = await this.getAllWorkspace();
            if(getWPResult.isOk) {
                this.workspaceOptions = getWPResult.data.data;
                this.selectedWorkspace = this.workspaceOptions.length > 0 ? this.workspaceOptions[0].id : "";
            }  
        },

        // ------ get data datatable ------
        async getData() {
            // state for loading overlay
            this.isBusy = true;

            // Call get data
            let rs = await this.getPBIDatasets(this.selectedWorkspace);
            if(rs.isOk) {
                // List data
                this.items = rs.data.data;
                // Total row
                this.totalRow = this.items.length;
                // Number show
                this.numberOfShow = ((this.currentPage - 1) * this.perPage) + this.items.length;
                // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.perPage)) + 1;
                // For export excel
                this.exportDatas = this.items.map(({ rowNumber, id, name }) => ({
                    rowNumber, id, name
                }));
            }

            this.isBusy = false;
        },        
        // sortingChanged
        async sortingChanged() {
            //console.log(this.perPage)
            await this.getData();
        },
        // function for paging
        async handlePageChange(page) {
            this.currentPage = page;
            //console.log(this.currentPage)
            await this.getData();
        },
        // function for select number in page
        async onChangePageOptions(perPage) {
            this.perPage = perPage;
            await this.getData();
        },
        // function for search key 
        async onSearchKey() {
            //console.log(this.filter)
            //this.filter = e.target.value
            await this.getData();
        },
        // function select item in table
        async selectRow(id) {
            if (this.selected.includes(id)) {
                this.selected.splice(this.selected.indexOf(id), 1);
            }
            else {
                this.selected.push(id);
            }
        },
        async selectAllRows(e) {
            if (e.target.checked) {
                this.selected = this.items.map((item) =>  item.id);
            }
            else {
                this.selected = [];
            }
        },

        // ------ on click ------
        async onClickRefreshDataset(item) {
            this.isLoading = true;
            await this.refreshDataset(item.id);
            this.isLoading = false;
        },

        async onClickSchedule(item) {
            this.isLoading = true;
            this.showScheduleModal();
            this.selectedDatasetId = item.id;
            let refreshScheduleRes = await this.getRefreshSchedule(item.id);
            this.numberOfScheduleStep = 0;
            if(refreshScheduleRes.isOk) {
                let refreshSchedule = refreshScheduleRes.data.data;
                this.refreshScheduleEnabled = refreshSchedule.enabled;
                let html = '';
                refreshSchedule.times.forEach(async time => {
                    this.numberOfScheduleStep++;
                    let timeArr = time.split(":");
                    let hourOptionHtml = '';
                    let minuteOptionHtml = '';
                    await Promise.all(this.hourOptions.map(e => {
                        if(e === timeArr[0]) {
                            hourOptionHtml += `<option value="${e}" selected>${e}</option>`
                        } else {
                            hourOptionHtml += `<option value="${e}">${e}</option>`
                        }
                    }));
                    await Promise.all(this.minuteOptions.map(e => {
                        if(e === timeArr[1]) {
                            minuteOptionHtml += `<option value="${e}" selected>${e}</option>`
                        } else {
                            minuteOptionHtml += `<option value="${e}">${e}</option>`
                        }
                    }));
                    html = `
                        <div class="row mb-1 schedule-step">
                            <div class="col-4">
                                <div class="d-flex">
                                    <select class="form-control" name="scheduleHours">
                                        ${hourOptionHtml}
                                    </select>
                                    <select class="form-control ml-1" name="scheduleMinutes">
                                        ${minuteOptionHtml}
                                    </select>
                                    <button class="btn btn-sm btn-outline-danger ml-1 remove-schedule-step">
                                        <i class="fa-solid fa-trash-can"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    `;
                    $('#selectSheduleTimes').append(html);

                    $('body').on('click', '.remove-schedule-step', function(){
                        $(this).parents('.schedule-step').remove();
                    });
                });
            }

            this.isLoading = false;
        },

        showScheduleModal() {
            $('#scheduleModal').modal("show");
        },

        hideScheduleModal() {
            $('#scheduleModal').modal("hide");
        },

        onAddScheduleStep() {
            let html = '';
            let hourOptionHtml = '';
            let minuteOptionHtml = '';
            this.hourOptions.map(e => {
                hourOptionHtml += `<option value="${e}">${e}</option>`
            });
            this.minuteOptions.map(e => {
                minuteOptionHtml += `<option value="${e}">${e}</option>`
            });
            html += `
                <div class="row mb-1 schedule-step">
                    <div class="col-4">
                        <div class="d-flex">
                            <select class="form-control" name="scheduleHours">
                                ${hourOptionHtml}
                            </select>
                            <select class="form-control ml-1" name="scheduleMinutes">
                                ${minuteOptionHtml}
                            </select>
                            <button class="btn btn-sm btn-outline-danger ml-1 remove-schedule-step">
                                <i class="fa-solid fa-trash-can"></i>
                            </button>
                        </div>
                    </div>
                </div>
            `;
            $('#selectSheduleTimes').append(html);

            $('body').on('click', '.remove-schedule-step', function(){
                $(this).parents('.schedule-step').remove();
            });

            this.numberOfScheduleStep++
        },


        convertTimezone(date, timezoneOffset) {
            // Create a new Date object with the UTC timestamp
            const utcDate = new Date(date);

            // Get the current timezone offset in minutes
            const currentOffset = utcDate.getTimezoneOffset();

            // Calculate the difference between desired and current offsets (in minutes)
            const offsetDiff = timezoneOffset - currentOffset;

            // Adjust the UTC date by the offset difference (in milliseconds)
            return new Date(utcDate.getTime() + offsetDiff * 60 * 1000);
        },
        

        async onClickHistoryRefresh(item) {
            this.isLoading = true;
            this.showRefreshHistoryModal();
            let refreshHistoryRes = await this.getRefreshHistory(item.id);
            if(refreshHistoryRes.isOk){
                let refreshHistory = refreshHistoryRes.data.data;
                // console.log(refreshHistory);
                let html = '';
                refreshHistory.forEach((e, i) => {
                    let newStartTime = this.convertTimezone(Date.parse(e.startTime), +7);
                    let newEndTime = this.convertTimezone(Date.parse(e.startTime), +7);
                    let status = '';
                    let htmlClass = '';
                    switch (e.status) {
                        case 'Completed': {
                            status = 'Hoàn thành';
                            htmlClass = 'text-success';
                            break;
                        }
                        case 'Failed': {
                            status = 'Thất bại';
                            htmlClass = 'text-danger';
                            break;
                        }
                        case 'Unknown': {
                            status = 'Đang thực thi...';
                            htmlClass = 'text-primary';
                            break;
                        }
                        default: {
                            status = 'Không xác định';
                            htmlClass = 'text-warning';
                        }
                    }
                    html += `
                        <tr>
                            <td style="vertical-align: middle !important;">${i + 1}</td>
                            <!-- <td style="vertical-align: middle;">${e.refreshType}</td> -->
                            <td style="vertical-align: middle;">${common.formatDateTime(newStartTime)}</td>
                            <td style="vertical-align: middle;">${common.formatDateTime(newEndTime)}</td>
                            <td style="vertical-align: middle;">
                                <span class="${htmlClass}">${status}</span>
                            </td>
                        </tr>
                    `;
                });
                $('#refreshHistoryTable tbody').html(html);
            }
            this.isLoading = false;
        },

        showRefreshHistoryModal() {
            $('#refreshHistoryModal').modal('show');
        },

        hideRefreshHistoryModal() {
            $('#refreshHistoryModal').modal('hide');
        },

        // ------ submit schedule ------
        async onSubmitSchedule() {
            this.isLoading = true;
            let hourSelected = [];
            let minuteSelected = []; 
            $('select[name="scheduleHours"]').each(function() {
                hourSelected.push($(this).val());
            });
            $('select[name="scheduleMinutes"]').each(function() {
                minuteSelected.push($(this).val());
            });
            let times = [];
            hourSelected.forEach((e,i) => {
                times.push(`${hourSelected[i]}:${minuteSelected[i]}`);
            });
            await this.updateRefreshSchedule({
                datasetId: this.selectedDatasetId,
                times: times,
                enabled: this.refreshScheduleEnabled
            });
            this.hideScheduleModal();
            this.isLoading = false;
        },

    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
        //Initialize Select2 Elements
        // $(".select2").select2();
        // //Initialize Select2 Elements
        // $(".select2bs4").select2({
        //     theme: "bootstrap4",
        // });
        // $('#pageOptions').on('change', e => {
        //     this.onChangePageOptions(e.target.value);
        // });
        $("#workspaceOptions").select2({
            theme: "bootstrap4",
        });
        $('#workspaceOptions').on('change', e => {
            this.selectedWorkspace = e.target.value;
            this.getData();
        });
    },
    async created() {

    }
}
</script>

<style>

</style>
